import { TimingMarker } from "@faire/web--source/common/timings/TimingMarker";
import { trackClientEventsClientSideLatencyTiming } from "@faire/web-api--source/events/clientEvents/timing/clientSideLatency";
import { logError } from "../../logging";
import { CLIENT_SIDE_LATENCY_HEADER } from "../request-interceptors/clientSideLatencyRequestInterceptor";
/**
 * Processes client-side latency timing for tracked requests.
 * Calculates request duration and tracks it if latency tracking is enabled.
 *
 * @param request - The original request options
 * @param response - The API response
 * @returns The unmodified API response
 */ export var clientSideLatencyResponseInterceptor = function(request, response) {
    var timing = request === null || request === void 0 ? void 0 : request.headers[CLIENT_SIDE_LATENCY_HEADER];
    if (request.trackClientSideLatency && timing) {
        var timingPair = {
            start: new TimingMarker(timing),
            end: new TimingMarker()
        };
        try {
            trackClientEventsClientSideLatencyTiming(timingPair, request.url);
        } catch (error) {
            logError(error);
        }
    }
    return response;
};
